'use client';

import type { HomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import type { TargetType } from './recent-select-modal/constants';
import { useState, type FC } from 'react';
import { IcArrowforwardFillNomargin, IcLocationFill } from '@yanolja-rnd/nol-icons';
import dynamic from 'next/dynamic';
import { clientLogStandardized } from '@weberus/client-tracker';
import { useAtomValue } from 'jotai';
import { expGroupsAtom } from '@/app/_shared/store/device';
import { TARGET_TO_REGION_TYPE } from './recent-select-modal/constants';

const RecentSelectModal = dynamic(() => import('./recent-select-modal').then((mod) => mod.RecentSelectModal), {
  ssr: false,
});

const SelectRegionModal = dynamic(
  () => import('@/app/(pages)/local/ui/select-region-modal').then((mod) => mod.SelectRegionModal),
  { ssr: false },
);

interface RecentSelectButtonProps {
  title: string;
  pageNameLog: HomeLogPageNameValue;
  targetType: string;
}

export const RecentSelectButton: FC<RecentSelectButtonProps> = ({ title, pageNameLog, targetType }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const expGroups = useAtomValue(expGroupsAtom);
  const isPlpSrpExpB = expGroups?.includes('LOCALPLPSRP2025:B');

  const resionType = TARGET_TO_REGION_TYPE[targetType as TargetType];

  return (
    <>
      <button
        className="flex max-w-[520px] grow items-center rounded-8 border border-fill-neutral-main pl-24 pr-20 text-left shadow-2"
        type="button"
        onClick={() => {
          setIsModalOpen(true);
          clientLogStandardized('click', pageNameLog, {
            object: 'regionSelectBtn',
            objectContainer: 'regionSelection',
            selectType: '지역선택',
          });
        }}>
        <IcLocationFill className="size-20 pc:size-24" />
        <span className="ml-6 grow typography-subtitle-16-bold pc:typography-subtitle-20-bold">{title}</span>
        <IcArrowforwardFillNomargin className="h-18 w-10 pc:h-20 pc:w-11" />
      </button>
      {isPlpSrpExpB ? (
        <SelectRegionModal
          type={resionType}
          isOpened={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
          }}
        />
      ) : (
        <RecentSelectModal
          targetType={targetType}
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
          }}
        />
      )}
    </>
  );
};
